import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";

const DraftOptions = ({
  onCreateWo,
  onEdit,
  onDuplicate,
  onDelete,
  onClose,
  canAssign = true,
  canEdit = true,
  canDuplicate = true,
  canDelete = true,
}) => {
  return (
    <OutsideClickHandler onOutsideClick={onClose}>
      <div className="flex flex-col items-center py-1 gap-2 absolute top-[24px] right-0 w-[30px] border-[1px] rounded-[6px] border-borderColor bg-white z-20 shadow-md">
        {canAssign && (
          <img
            onClick={onCreateWo}
            className="w-[15px] h-[15px] object-contain cursor-pointer"
            src={getImageUrl("/images/common/wo.png")}
            alt="Assign WO"
            title="Assign WO"
          />
        )}
        {canEdit && (
          <img
            onClick={onEdit}
            className="w-[14px] h-[14px] object-contain cursor-pointer"
            src={getImageUrl("/images/common/edit.png")}
            alt="Edit"
            title="Edit"
          />
        )}
        {canDuplicate && (
          <img
            onClick={onDuplicate}
            className="w-[15px] h-[15px] object-contain cursor-pointer"
            src={getImageUrl("/images/common/white_duplicate.png")}
            alt="Duplicate"
            title="Duplicate"
          />
        )}
        {canDelete && (
          <img
            onClick={onDelete}
            className="w-[14px] h-[14px] object-contain cursor-pointer"
            src={getImageUrl("/images/common/black_trash.png")}
            alt="Delete"
            title="Delete"
          />
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default DraftOptions;
